<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
    />
    <ik-data-table
      v-if="!loading"
      ref="table"
      :entity-name="entityName"
      :fixed-filter="filter"
      :icon="'mdi-heart'"
      :model="Attribute"
    >
      <template #navigation>
        <back-button @close-event="$router.back()" />
      </template>
      <template #right>
        <v-btn
          :small="$vuetify.breakpoint.mobile"
          :style="!$vuetify.breakpoint.mdAndUp ? '' : 'background: white;'"
          class="ml-2 pa-2"
          elevation="0"
          outlined
          @click="showThisGroupAttribute = true"
        >
          <template v-if="!$vuetify.breakpoint.mdAndUp">
            <v-icon
              color="black"
              left
            >
              mdi-drag-variant
            </v-icon>
          </template>
          {{ $t('editShowSort') }}
        </v-btn>
      </template>
      <template #footer>
        <!-- Display information about attributes here if needed -->
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showThisGroupAttribute"
      max-width="600px"
    >
      <v-card
        min-height="600px"
      >
        <sort-fragment
          v-if="showThisGroupAttribute"
          :initial-list="attributeList"
          item-sort="value"
          @close="showThisGroupAttribute=false"
          @save="updateSort"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Attribute from '@/model/dataLayer/api/dish/Attribute'
import SortFragment from '@/views/AadenPages/dishes/dish/widget/SortFragment'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import IKUtils from 'innerken-js-utils'
import AttributeGroup from '@/model/dataLayer/api/dish/AttributeGroup'
import { showSuccessMessage } from '@/model/utils/utils'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'

export default {
  name: 'AttributePage',
  components: {
    SortFragment,
    IkDataTable,
    BackButton
  },
  props: {
    groupId: {}
  },
  data: function () {
    return {
      attributeList: [],
      showThisGroupAttribute: null,
      currentAttributeGroup: null,
      Attribute,
      loading: true,
      filter: null
    }
  },
  computed: {
    entityName () {
      return this.$t('attribute') + (this.currentAttributeGroup ? ' · ' + this.currentAttributeGroup.name : '')
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async reload () {
      this.loading = true
      if (this.groupId) {
        this.filter = { attributeGroupId: parseInt(this.groupId) }

        this.currentAttributeGroup =
            (await AttributeGroup.getList(true)).find(it => it.id === parseInt(this.groupId))
        this.attributeList =
            (await Attribute.getList(true))
              .filter(it => it.attributeGroupId === parseInt(this.groupId))
      }
      this.loading = false
      this.$nextTick(() => {
        this.$refs.table.reload()
      })
    },
    async updateSort (newList) {
      IKUtils.showLoading()
      const reqs = newList.map(async (it, i) => {
        it.value = i + 1
        return await this.Attribute.edit(it)
      })
      await Promise.allSettled(reqs)
      showSuccessMessage()
      this.showThisGroupAttribute = false
      await this.reload()
    }
  }
}
</script>
